export default "__VITE_ASSET__DgeSi2dh__"